import CopyTimesModal from './CopyTimesModal';

export default CopyTimesModal;
